/**
 * PURPOSE:
 * Aislar los consumos públicos de KarateSoft usados por Hayllis.
 *
 * RESPONSIBILITIES:
 * - Consumir únicamente endpoints públicos/livianos del backend de KarateSoft.
 * - Mantener separada la API de KarateSoft de la API principal de Hayllis.
 * - Normalizar el API base para evitar dobles slash al cambiar Railway/localhost.
 *
 * COLLABORATORS:
 * - src/config/config_karate.js
 * - src/components/Software/Karate/Categorias/CategoriasKarate.jsx
 *
 * ROUTE:
 * src/components/Software/Karate/services/karateCategoryService.js
 */

import axios from "axios";
import API_BASE_KARATE_URL from "../../../../../config/config_karate.js";

const API_BASE = String(API_BASE_KARATE_URL || "").replace(/\/+$/, "");

/** Obtiene categorías públicas y livianas para el link público de Karate. */
export async function getPublicKarateCategoriesForHayllis() {
  const response = await axios.get(`${API_BASE}/category/public/hayllis`);
  return response.data;
}

/** Obtiene el detalle público de llave de una categoría de Karate. */
export async function getPublicKarateBracketCategory(categoryId) {
  const safeId = Number(categoryId);

  if (!Number.isFinite(safeId) || safeId <= 0) {
    throw new Error("categoryId inválido para consultar la llave pública de Karate");
  }

  const response = await axios.get(`${API_BASE}/category/public/hayllis/${safeId}/bracket`);
  return response.data;
}
